<template>
  <EditProfile
    v-model="payload"
    @save="save"/>
</template>

<script>
import _ from 'lodash';
import { mapGetters, mapActions, mapState } from 'vuex';
import EditProfile from '@/components/User/EditProfile.vue';

export default {
  components: {
    EditProfile,
  },
  data() {
    return {
      payload: null,
    };
  },
  computed: {
    ...mapState({
      countries: (state) => state.settings.countries,
    }),
    ...mapGetters({
      contractorsGetter: 'contractors/contractors',
      enumsGetter: 'settings/selectEnums',
      regionsGetter: 'settings/regions',
    }),
    enums() {
      return {
        legalType: this.enumsGetter('legalType') || [],
        taxSystem: this.enumsGetter('taxSystem') || [],
      };
    },
    id() {
      return _.get(this.$route, 'params.id');
    },
    contractor() {
      if (this.id) {
        return this.contractorsGetter(this.id);
      }
      return null;
    },
    isRegistrationRequest() {
      return !_.get(this.contractor.registered) && !_.get(this.contractor.verified);
    },
    isChangeRequest() {
      return !!_.get(this.contractor.registered) && !_.get(this.contractor.verified);
    },
  },
  methods: {
    ...mapActions({
      fetch: 'contractors/ACT_FETCH_CONTRACTOR',
      fetchRegions: 'settings/ACT_FETCH_REGIONS',
      update: 'contractors/ACT_CONTRACTOR_UPDATE',
    }),
    setPayload(data) {
      if (!data.legalInfo) {
        this.payload = { ...data };
        return;
      }
      this.payload = {
        ...data,
        legalInfo: {
          ...data.legalInfo,
          individual: {},
          organization: {
            ogrn: '',
            contactName: '',
            contactPhone: '',
            bankCode: '',
            bankAccount: '',
            managerName: '',
            ...((data.legalInfo && data.legalInfo.organization) || {}),
          },
        },
      };
    },
    save(event) {
      this.update({
        id: this.id,
        payload: event,
      }).then(() => {
        this.$router.push({
          name: 'contractors.details',
          params: {
            id: this.id,
          },
        });
      });
    },
  },
  watch: {
    id: {
      handler() {
        this.fetch(this.id).then((value) => {
          this.setPayload(_.cloneDeep(value));
        });
      },
      immediate: true,
    },
  },
};
</script>
